import {  createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { purchaseEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
 
}


const purchaseEntrySlice = createSlice({
  name: purchaseEntry,
  initialState,
  reducers: {
   
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
  },
  
})

export const {  setDetailParams, resetDetailParams, setNewEntryMode } = purchaseEntrySlice.actions
export default purchaseEntrySlice.reducer
